import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Flights from "@/pages/Flights";
import Hotels from "@/pages/Hotels";
import Holidays from "@/pages/Holidays";
import CarHire from "@/pages/CarHire";
import Umrah from "@/pages/Umrah";
import Hajj from "@/pages/Hajj";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminReset from "@/pages/AdminReset";
import ManageBooking from "@/pages/ManageBooking";
import { ChatWidget } from "@/components/ChatWidget";
import { LiveBooking } from "@/components/LiveBooking";

const Shell = ({ children }) => {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  return (
    <div className="App">
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <ChatWidget />}
      {!isAdmin && <LiveBooking />}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <CurrencyProvider>
        <Shell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/live-flights" element={<Flights />} />
            <Route path="/flights" element={<Flights />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/holidays" element={<Holidays />} />
            <Route path="/car-hire" element={<CarHire />} />
            <Route path="/umrah" element={<Umrah />} />
            <Route path="/hajj" element={<Hajj />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/manage-booking" element={<ManageBooking />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/reset" element={<AdminReset />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </Shell>
        </CurrencyProvider>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
